import gql from "graphql-tag";

export default gql`
  query schoolOrDistrictRegistration($id: ID!) {
    schoolOrDistrictRegistration(id: $id) {
      paymentStatus
      agreementStatus
      registrant {
        email
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/utils/schoolOrDistrictRegistration.query.js